import { render, staticRenderFns } from "./listamail.vue?vue&type=template&id=0645f096&scoped=true&"
import script from "./listamail.vue?vue&type=script&lang=js&"
export * from "./listamail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0645f096",
  null
  
)

export default component.exports